import { ReactNode } from 'react'
import { Flex, GridItem } from '@nilohealth/core-ui'

interface DashboardTitleProps {
  children: ReactNode
}
const DashboardTitle = ({ children }: DashboardTitleProps) => {
  return (
    <GridItem column="1 / -1" css={{ width: '100%', marginBottom: '$xxsmall' }}>
      <Flex justify="between" align="start" css={{ margin: '$xxsmall 0 $xxxsmall 0', width: '100%' }}>
        <Flex direction="column" gap="quarck" css={{ width: '100%' }}>
          {children}
        </Flex>
      </Flex>
    </GridItem>
  )
}

export default DashboardTitle
